/**
 *
 * @param {object} props
 * @param {string} [props.src] The source of the logo.
 * @param {string} [props.alt] The alt text for the logo.
 * @param {React.CSSProperties} [props.style] The style for the logo.
 */
function SurveyLogo({ src, alt = "", style }) {
    return (
        <img
            src={src}
            alt={alt}
            style={{
                maxHeight: "64px",
                maxWidth: "320px",
                ...style,
            }}
        />
    );
}

export default SurveyLogo;
